import React from 'react';
import { Modal, Table } from 'react-bootstrap';

export const ACTION_TYPE_LABELS: Record<string, string> = {
  status_change: 'Изменение статуса',
  tz_confirm: 'Подготовка ТЗ',
  new_product_confirm: 'Подтверждение нового товара',
  stop_list_add: 'Добавление в стоп-лист',
  stop_list_remove: 'Удаление из стоп-листа',
  field_update: 'Изменение поля',
  description_update: 'Изменение описания',
  season_update: 'Изменение сезона',
  image_upload: 'Загрузка изображения',
  image_delete: 'Удаление изображения',
  package_info_update: 'Обновление упаковки',
  eng_name_update: 'Изменение англ. названия',
  eng_desc_update: 'Изменение англ. описания',
  name_update: 'Изменение названия'
};

export function getActionTypeLabel(actionType: string): string {
  if (ACTION_TYPE_LABELS[actionType]) return ACTION_TYPE_LABELS[actionType];
  return actionType || 'Другое';
}

interface ActionTypesModalProps {
  show: boolean;
  onHide: () => void;
  data: { action_type: string; count: number }[];
  periodLabel?: string;
  /** При клике по строке — открыть историю по этому типу действия */
  onSelectActionType?: (actionType: string) => void;
}

const ActionTypesModal: React.FC<ActionTypesModalProps> = ({ show, onHide, data, periodLabel, onSelectActionType }) => {
  const total = data.reduce((sum, row) => sum + row.count, 0);

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>События по типам действий</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {periodLabel && <p className="text-muted small mb-3">{periodLabel}</p>}
        {data.length === 0 ? (
          <p className="text-muted mb-0">Нет событий за выбранный период.</p>
        ) : (
          <>
            <p className="mb-2">Всего событий: <strong>{total}</strong>. Клик по строке — посмотреть свою историю по типу.</p>
            <Table responsive variant="dark" size="sm" hover>
              <thead>
                <tr>
                  <th>Тип действия</th>
                  <th className="text-end">Количество</th>
                </tr>
              </thead>
              <tbody>
                {data.map((row) => (
                  <tr
                    key={row.action_type}
                    onClick={() => onSelectActionType?.(row.action_type)}
                    style={onSelectActionType ? { cursor: 'pointer' } : undefined}
                    role={onSelectActionType ? 'button' : undefined}
                  >
                    <td>{getActionTypeLabel(row.action_type)}</td>
                    <td className="text-end">{row.count}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ActionTypesModal;
